import https from "@/lib/https";
import type { ProfileDetail } from "@/interface/auth";
import type { ApiResponse, PaginationRequest, PaginationResponse } from "@/interface/common";
import type { ProfileSkillDetail } from "@/interface/profileSkill";
import type { ProjectDetail } from "@/interface/project";
import type { EducationDetail } from "@/interface/education";
import type { CertificationDetail } from "@/interface/certification";
import type { AwardDetail } from "@/interface/award";
import type { ExperienceDetail } from "@/interface";

export * from "@/pages/profile/employee/sections/api/profile.api";
export * from "@/pages/profile/employee/sections/api/skills.api";
export * from "@/pages/profile/employee/sections/api/projects.api";
export * from "@/pages/profile/employee/sections/api/education.api";
export * from "@/pages/profile/employee/sections/api/experience.api";
export * from "@/pages/profile/employee/sections/api/certifications.api";
export * from "@/pages/profile/employee/sections/api/awards.api";

const PROFILES_URL = "/api/profiles/";

export const getCandidateProfileById = async (
  id: number | string,
): Promise<ApiResponse<ProfileDetail>> => {
  return await https.get<ApiResponse<ProfileDetail>>(`${PROFILES_URL}${id}/`);
};

export const getCandidateSkills = async (
  id: number | string,
  params?: PaginationRequest,
): Promise<ApiResponse<PaginationResponse<ProfileSkillDetail>>> => {
  return await https.get<ApiResponse<PaginationResponse<ProfileSkillDetail>>>(
    `${PROFILES_URL}${id}/skills/`,
    params,
  );
};

export const getCandidateProjects = async (
  id: number | string,
  params?: PaginationRequest,
): Promise<ApiResponse<PaginationResponse<ProjectDetail>>> => {
  return await https.get<ApiResponse<PaginationResponse<ProjectDetail>>>(
    `${PROFILES_URL}${id}/projects/`,
    params,
  );
};

export const getCandidateEducation = async (
  id: number | string,
  params?: PaginationRequest,
): Promise<ApiResponse<PaginationResponse<EducationDetail>>> => {
  return await https.get<ApiResponse<PaginationResponse<EducationDetail>>>(
    `${PROFILES_URL}${id}/education/`,
    params,
  );
};

export const getCandidateExperiences = async (
  id: number | string,
  params?: PaginationRequest,
): Promise<ApiResponse<PaginationResponse<ExperienceDetail>>> => {
  return await https.get<ApiResponse<PaginationResponse<ExperienceDetail>>>(
    `${PROFILES_URL}${id}/experiences/`,
    params,
  );
};

export const getCandidateCertifications = async (
  id: number | string,
  params?: PaginationRequest,
): Promise<ApiResponse<PaginationResponse<CertificationDetail>>> => {
  return await https.get<ApiResponse<PaginationResponse<CertificationDetail>>>(
    `${PROFILES_URL}${id}/certifications/`,
    params,
  );
};

export const getCandidateAwards = async (
  id: number | string,
  params?: PaginationRequest,
): Promise<ApiResponse<PaginationResponse<AwardDetail>>> => {
  return await https.get<ApiResponse<PaginationResponse<AwardDetail>>>(
    `${PROFILES_URL}${id}/awards/`,
    params,
  );
};
